function setShipDate() {
  // element to write date to
  var shipdate = document.getElementById("js-ship-date");

  // Set dates considering noOfDaysToAdd
  var startDate = new Date();

  var endDate = "",
    noOfDaysToAdd = document.getElementById("noOfDaysToAdd").innerHTML,
    count = 0;

  var holidays = [
    [2026, 01, 01], //New Year's Day
    [2026, 01, 19], //Martin Luther King Jr. Day
    [2026, 02, 16], //Presidents Day
    [2026, 05, 25], //Memorial Day
    [2026, 06, 19], //Juneteenth National Independence Day
    [2026, 07, 03], //Independence Day Observed
    [2026, 09, 07], //Labor Day
    [2026, 10, 12], //Indigenous Peoples Day
    [2026, 11, 11], //Veterans Day
    [2026, 11, 26], //Thanksgiving
    [2026, 12, 25], //Christmas Day
    [2027, 01, 01], //New Year's Day
 
    [2026, 04, 20], //Closed
    [2026, 04, 21], //Closed
    [2026, 04, 22], //Closed
    [2026, 04, 23], //Closed
    [2026, 04, 24], //Closed
    [2026, 04, 27], //Closed
    [2026, 04, 28], //Closed

    [2026, 05, 01], //Closed

    [2026, 06, 10], //Closed
    [2026, 06, 11], //Closed
    [2026, 06, 12], //Closed
    [2026, 06, 15], //Closed
    [2026, 06, 16], //Closed
    [2026, 06, 17], //Closed
    [2026, 06, 18], //Closed
    
    [2026, 07, 02], //Closed
    [2026, 07, 13], //Closed
    [2026, 07, 14], //Closed

    [2026, 09, 11], //broken equipment
    [2026, 09, 14], //broken equipment
    [2026, 09, 15], //broken equipment
    [2026, 09, 16], //broken equipment
    [2026, 09, 17], //broken equipment
    [2026, 09, 18], //broken equipment

    [2026, 11, 25], //Closed
    [2026, 11, 27], //Closed

    [2026, 12, 21], //Closed
    [2026, 12, 22], //Closed
    [2026, 12, 23], //Closed
    [2026, 12, 24], //Closed
    [2026, 12, 28], //Closed
    [2026, 12, 29], //Closed
    [2026, 12, 30], //Closed
    [2026, 12, 31], //Closed
    
    [2027, 01, 04], //Closed
    [2027, 01, 05], //Closed
    
  ];

  // Numeric to written months
  var month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Check if there are personal/holidays
  function isHoliday(endDate) {
    var year = endDate.getFullYear(),
      month = endDate.getMonth(),
      day = endDate.getDate();

    return holidays.some(function (d) {
      return d[0] == year && d[1] == month + 1 && d[2] == day;
    });
  }

  // Loop
  while (count < noOfDaysToAdd) {
    // add a day to the end date each loop
    endDate = new Date(startDate.setDate(startDate.getDate() + 1));

    // only count when if it's a working day (exclude weekends and personal/holidays)
    if (endDate.getDay() != 0 && endDate.getDay() != 6 && !isHoliday(endDate)) {
      count++;
    }
  }

  // update shipdate HTML
  shipdate.innerHTML = month[endDate.getMonth()] + " " + endDate.getDate();
}

document.onreadystatechange = function () {
  if (document.readyState == "interactive") {
    setShipDate();
  }
};
